export default __webpack_public_path__ + "static/media/14.754fbe4b.jpg";